//===================Edit script
const editButton = document.querySelector('product-info-sticky [js-edit-btn]');
editButton?.addEventListener('click', (event)=> {
    event.preventDefault();
    let scrollTo = 0;
    if(document.querySelector('.section-main-product')) scrollTo = document.querySelector('.section-main-product').offsetTop;
    let offsetTop = -60;
    if(window.innerWidth <= 749)  offsetTop = 200;
    window.scroll({
      top: scrollTo + offsetTop,
      behavior: 'smooth'
    });
});


//================scroll script
document.addEventListener("DOMContentLoaded", function () {
  const $stickyEl = document.querySelector('product-info-sticky');
  const chatWidget = document.getElementById('gladlyChat_container');
  const mainAddToCart = document.querySelector('div[data-section-type="main-product"] form.product-purchase-form');
  const footer = document.getElementById('shopify-section-footer');

  // Reset sticky element and chat widget
  const setStickyActive = (isActive) => {
    if (!$stickyEl) return;

    if (isActive) {
      $stickyEl.classList.add('active');
      if (chatWidget) {
        chatWidget.style.setProperty("bottom", window.innerWidth >= 992 ? "80px" : "125px", "important");
      }
      document.querySelector('.Footer_inner_new').classList.add('gg-footer-padding-bottom');
    } else {
      $stickyEl.classList.remove('active');
      document.querySelector('.Footer_inner_new').classList.remove('gg-footer-padding-bottom');
      if (chatWidget) {
        chatWidget.style.setProperty("bottom", "0px", "important");
      }
    }
  };

  // Observer for footer
  if (footer) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Footer is visible: hide sticky
            setStickyActive(false);
          }
        });
      },
      {
        root: null,
        threshold: 0.1 // Partially in view
      }
    );
    footerObserver.observe(footer);
  }

  // Observer for mainAddToCart (reverse logic)
  if (mainAddToCart) {
    const addToCartObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && window.scrollY > (window.innerWidth >= 992 ? 700 : 600)) {
            // Add to cart is out of view & scrolled enough
            setStickyActive(true);
          } else {
            setStickyActive(false);
          }
        });
      },
      {
        root: null,
        threshold: 0.1 // Adjust as needed
      }
    );
    addToCartObserver.observe(mainAddToCart);
  }
});


//==========Add to cart script
const $formContainer = $('product-info-sticky .product-form');
$('product-info-sticky')?.find('form.product-purchase-form').each(function () {
      var $form = $(this);
     
      $form.on('submit', function (evt) {
    
        // Validate
        // if (!theme.validateProductForm($formContainer)) {
        //   return false;
        // }

        // Ajax-add
        if (theme.settings.after_add_to_cart !== 'no-js' && $formContainer.is('[data-ajax-add-to-cart="true"]')) {
          evt.preventDefault();

          var shopifyAjaxAddURL = theme.routes.cart_add_url;

          // Disable add button
          $form.find('button[type="submit"]').addClass('btn--in-progress').attr('disabled', 'disabled');

          // Add to cart
          let formData = new FormData($form[0]);
          formData.append('sections', 'cart-drawer');
          $.post(shopifyAjaxAddURL, new URLSearchParams(formData).toString(), theme.addedToCartHandler.bind($form), 'json').fail(function (data) {
            // Enable add button
            $form.find('button[type="submit"]').removeClass('btn--in-progress').removeAttr('disabled');
            // Not added, show message
            if (typeof data !== 'undefined' && typeof data.status !== 'undefined') {
              const response = $.parseJSON(data.responseText);
              let error = typeof response.description === 'string' ? response.description : response.message;
              if (response.errors && typeof response.errors === 'object') {
                error = Object.entries(response.errors).map((item) => item[1].join(', '));
              }
              const errorElement = document.createElement('div');
              const errorArray = Array.isArray(error) ? error : [error];
              errorArray.forEach((err, index) => {
                if (index > 0) errorElement.insertAdjacentHTML('beforeend', '<br>');
                errorElement.insertAdjacentText('beforeend', err);
              });
              theme.showQuickPopup(errorElement.innerHTML, $form.find('button[type="submit"]:first'), 'error');
            } else {
              // Some unknown error? Disable ajax and add the old-fashioned way.
              $formContainer.attr('ajax-add-to-cart', 'false');
              $form.submit();
            }
          });
        }
      });
    });
